// extracted by mini-css-extract-plugin
export default {"container":"sort-by_container__PlHE8"};